import { createContext, useContext, useRef, PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';

type NavigationHistory = {
  previousPathname: string | null;
};

const NavigationHistoryContext = createContext<NavigationHistory>({
  previousPathname: null,
});

export const NavigationContextProvider = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const previousPathnameRef = useRef<string | null>(null);
  const currentPathnameRef = useRef<string | null>(null);

  if (location.pathname !== currentPathnameRef.current) {
    previousPathnameRef.current = currentPathnameRef.current;
    currentPathnameRef.current = location.pathname;
  }

  return (
    <NavigationHistoryContext.Provider
      value={{ previousPathname: previousPathnameRef.current }}
    >
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export const useNavigationContext = () => useContext(NavigationHistoryContext);
